import { Component, Input, OnInit } from '@angular/core';

import { IModalComponent, IModalData } from '@app/interfaces';
import { copyText } from '@utils/helpers';
import { PartnerAccountToOnboard, PartnerLink } from '../../../interfaces/partner-links.interface';
import { PartnerOnboardingService } from '../../../services/partner-onboarding-service/partner-onboarding.service';
import { PartnerService } from '../../../services/partner.service';

export interface IOnboardAccountsOptions {
	links: PartnerLink[];
	isReonboard: boolean;
}

@Component({
	selector: 'app-partner-onboard-accounts-modal',
	templateUrl: './partner-onboard-accounts-modal.component.html',
	styleUrls: ['./partner-onboard-accounts-modal.component.scss'],
})
export class PartnerOnboardAccountsModalComponent implements IModalComponent<IOnboardAccountsOptions>, OnInit {
	@Input() data: IModalData<IOnboardAccountsOptions>;

	links: PartnerLink[];

	copyToClipboard = copyText;
	isSameCurBucketName = true;

	constructor(private partnerService: PartnerService, private onboardingService: PartnerOnboardingService) {}

	get validArnLinks(): PartnerLink[] {
		return this.links.filter((l) => l.arn && l.arn.length >= 40);
	}

	ngOnInit() {
		this.links = this.data.options['links'];
		if (this.data.options['isReonboard']) {
			this.isSameCurBucketName = this.links.every((l, i, arr) => l.cur_bucket_name === arr[0].cur_bucket_name);
		}
	}

	closeEvent(e?: {}): void {}

	checkARN(row) {
		row.arnInProgress = true;
		const arn = row.arn.trim();

		this.partnerService.checkARN(row.uuid, arn).subscribe({
			next: (val) => {
				row.arnInProgress = false;
				row.arnIsValid = val.status;
			},
		});
	}

	onboardAccounts() {
		const accountsToOnboard: PartnerAccountToOnboard[] = this.validArnLinks.map((link) => ({
			account_uuid: link.uuid,
			company_name: link.organization,
			account_alias: link.account_name,
			org_id: link.org_id,
			is_reonboard: link.is_reonboard,
			arn: link['arn'],
			isOnboarded: false,
		}));
		this.onboardingService.onboardingInProgress$.next(true);
		this.onboardingService.accountsToOnboard = accountsToOnboard;
		this.onboardingService.curBucketName = this.links[0].cur_bucket_name;
		this.onboardingService.progressBar.accountsTotal = accountsToOnboard.length;
		this.onboardingService.checkArnValidity();

		this.closeEvent({ message: 'finishOnboarding' });
	}
}
